module.exports = __webpack_public_path__ + "img/gud-logo.64866d78.png";